import React, { useEffect, useRef, useState } from "react";
import { Collapse, makeStyles } from "@material-ui/core";
import SEO from "../components/SEO";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import clsx from "clsx";

import "swiper/css";
import "swiper/css/autoplay";

import LazyImage from "../components/v4/LazyLoadImage/LazyImage";
import Link from "../components/v2/Link";
import ClientScroll from "../components/v4/clientScroll/ClientScroll";
import TruestedSection from "../components/v4/TrustedSection/TruestedSection";
import FaqSection from "../components/v4/FaqSection/FaqSection";
import TestimonialSlider from "../components/v3/TestimonialSlider/TestimonialSlider";

import teamsPageHeroImg from "../images/v4/user-based-tools/masterSheet/images/heroimg.webp";
import industryPageHerobg from "../images/v4/user-based-tools/masterSheet/images/heroImgBg.png";
import moreSideRightButton from "../images/v4/user-based-tools/masterSheet/icons/learnmoreright.png";
import teamsPerfomanceImg from "../images/v4/user-based-tools/masterSheet/images/teamsPerfomanceImg.png";
import industryadaptbg from "../images/v4/user-based-tools/masterSheet/images/industryadaptbg.png";
import industryIntegration from "../images/v4/user-based-tools/masterSheet/images/industryIntegration.png";

import industryintegrationImg from "../images/v4/user-based-tools/masterSheet/images/industryintegrationImg.png";
import bussinessSuccessbg from "../images/v4/user-based-tools/masterSheet/images/bussinessSuccessbg.png";

import contentIcon1 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon1.svg";
import contentIcon2 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon2.svg";
import contentIcon3 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon3.svg";
import contentIcon4 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon4.svg";
import contentIcon5 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon5.svg";
import contentIcon6 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon6.svg";
import contentIcon7 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon7.svg";
import contentIcon8 from "../images/v4/user-based-tools/masterSheet/icons/contentIcon8.svg";

import adaptImg1 from "../images/v4/user-based-tools/masterSheet/icons/adaptImg1.svg";
import adaptImg2 from "../images/v4/user-based-tools/masterSheet/icons/adaptImg2.svg";
import adaptImg3 from "../images/v4/user-based-tools/masterSheet/icons/adaptImg3.svg";
import adaptImg4 from "../images/v4/user-based-tools/masterSheet/icons/adaptImg4.svg";
import adaptImg5 from "../images/v4/user-based-tools/masterSheet/icons/adaptImg5.svg";
import adaptImg6 from "../images/v4/user-based-tools/masterSheet/icons/adaptImg6.svg";

import partnerIcon1 from "../images/v4/aiPage/icons/partnerIcon1.png";
import partnerIcon2 from "../images/v4/aiPage/icons/partnerIcon2.png";
import partnerIcon3 from "../images/v4/aiPage/icons/partnerIcon3.png";
import partnerIcon5 from "../images/v4/aiPage/icons/partnerIcon5.png";
import partnerIcon6 from "../images/v4/aiPage/icons/partnerIcon6.png";
import partnerIcon7 from "../images/v4/aiPage/icons/partnerIcon7.png";
import partnerIcon8 from "../images/v4/aiPage/icons/partnerIcon8.png";

import leadCaptureIcon from "../images/v4/industryPage/leadCpature.png";
import quatationIcon from "../images/v4/industryPage/quatation.png";
import contactManagemntIcon from "../images/v4/industryPage/contactManagement.png";
import pipelineIcon from "../images/v4/industryPage/pipeline.png";
import omniChannelIcon from "../images/v4/industryPage/omnichannel.png";
import emailMarketingIcon from "../images/v4/industryPage/emailmarketing.png";
import salesForecastIcon from "../images/v4/industryPage/salesForecast.png";
import opportunityMangeIcon from "../images/v4/industryPage/opportunityManagement.png";
import aiChatbotIcon from "../images/v4/industryPage/aiChatbot.png";
import whatsappCrmIcon from "../images/v4/industryPage/whatsappCrm.png";
import mobileCrmIcon from "../images/v4/industryPage/mobileCrm.png";
import utmTrackingIcon from "../images/v4/industryPage/utmTracking.png";
import realTimeDashboardIcon from "../images/v4/industryPage/realTimeDashboard.png";
import voipToolIcon from "../images/v4/industryPage/voipTool.png";
import videoConferencingIcon from "../images/v4/industryPage/videoConference.png";

const useStyles = makeStyles((theme) => ({
  IndustrySection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${industryPageHerobg})`,
    padding: "60px 0 40px",
    "& $aiSectionLeft": {
      width: "50%",
      gap: "25px",
    },
    "& .container": {
      paddingBottom: "40px",
    },

    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
      marginTop: "70px",
    },
    "@media only screen and (max-width: 600px)": {
      "& $aiSectionLeft": {
        width: "100%",
      },
      paddingTop: "0px",
      "& .centerContainer": {
        width: "100%",
        marginTop: "30px",
      },
      "& .container": {
        paddingBottom: "20px",
      },
    },
  },
  aiSectionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "60px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  aiSectionLeft: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    width: "50%",
    gap: "20px",
    "& .highlighterText": {
      background: "linear-gradient(90deg, #7AFFAB 0%, #80C8FF 100%)",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  aiSectionRight: {
    width: "40%",
    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
  },
  integrationindustryHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    width: "100%",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "30px",
    },
  },
  integrationContent: {
    width: "100%",
    textAlign: "center",
    margin: "0 auto 48px",
    "& h2": {
      marginBottom: "16px !important",
      marginTop: "0 !important",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      marginBottom: "20px",
    },
  },

  performanceSection: {
    padding: "40px 0",
    backgroundImage: `url(${teamsPerfomanceImg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "& $integrationLeft": {
      width: "50%",
      gap: "20px",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "fle-start",
    },
    "@media only screen and (max-width: 600px)": {
      padding: "40px 0",
      "& $integrationLeft": {
        width: "100%",
      },
    },
  },
  bussinessSuccesSection: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${bussinessSuccessbg})`,
    paddingBottom: "200px",
    paddingTop: "100px",
    "& .logos-container": {
      background: "transparent",
      "&::before,&::after": {
        display: "none",
      },
      "& .logo": {
        backgroundColor: "#208EEC26",
        color: "#B6DDFF",
        "& img": {
          width: "48px",
          height: "48px",
        },
      },
    },
    "@media only screen and (max-width: 600px)": {
      padding: "80px 0 120px",
    },
    "& $integrationContent":{
      paddingLeft:'15px',
      paddingRight:'15px'
    }
  },
  statsContainer: {
    display: "flex",
    alignItems: "stretch",
    flexWrap: "wrap",
    gap: "24px",
    justifyContent: "flex-start",
    width: "100%",
    marginTop: "40px",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
      gap: "15px",
      marginTop: "20px",
      position: "relative",
    },
  },
  customerExperencesBox: {
    width: "32%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: "50px",
    background:
      "linear-gradient(129deg, rgba(255, 255, 255, 0.10) 0%, rgba(158, 90, 213, 0.10) 100%)",
    borderRadius: "16px",
    padding: "20px",
    minHeight: "230px",
    backdropFilter: "blur(30px) brightness(0.8)",
    overflow: "hidden",
    transition: ".2s ease-in-out",
    "&:hover": {
      background:
        "linear-gradient(129deg, rgba(255, 255, 255, 0.30) 0%, rgba(158, 90, 213, 0.30) 100%)",
    },
    "& p:nth-child(2)": {
      color: "#fff",
    },
    "& p:last-child": {
      color: "#fff",
    },
    "@media only screen and (max-width: 600px)": {
      width: "100%",
      gap: "15px",
      padding: "15px",
      borderRadius: "20px",
      minHeight: "max-content",
    },
    "&.orangeCard1": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard3": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard7": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.orangeCard5": {
      background: "#401960",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #FF8958 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.blueCard3": {
      background: "rgba(0, 154, 153, 0.4)",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #1ADAD9 50%, #00aa7c 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard0": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard2": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard4": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.regularCard6": {
      background: "#210538",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #9B42E3 50%, #21053800 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
    "&.greenCard7": {
      background: "#002C51",
      "&.glass-effect": {
        "&::before": {
          content: '""',
          position: "absolute",
          width: "250px",
          height: "250px",
          zIndex: "-1",
          background: "radial-gradient(circle, #208EEC 50%, #002C51 50%)",
          borderRadius: "50%",
          filter: "blur(100px)",
          opacity: "var(--before-opacity, 0)",
          left: "var(--before-left, 0)",
          top: "var(--before-top, 0)",
          transition: "opacity 0.3s ease",
          pointerEvents: "none",
        },
      },
    },
  },
  customerExperencesBoxBody: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    flex: "1",
    alignItems: "stretch",
    gap: "24px",

    "@media only screen and (max-width: 600px)": {
      width: "100%",
    },
    "& .description": {
      flex: "1",
    },
  },
  learnMorelink: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  moreSideButton: {
    width: "42px",
    minWidth: "42px",
    minHeight: "42px",
    height: "42px",
    position: "relative",
    borderRadius: "50%",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "0",
      left: "0",
      width: "100%",
      height: "100%",
      opacity: "0.2",
      backgroundColor: "#fff",
    },
    "& img": {
      width: "24px",
      height: "24px",
      transform: "rotate(-90deg)",
    },
  },
  statsFontImg: {
    width: "48px",
    height: "48px",
    "& img": {
      width: "100%",
      height: "100%",
    },
  },

  adaptFeatures: {
    paddingTop: "0",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundImage: `url(${industryadaptbg})`,
    "& .header": {
      display: "flex",
      width: "100%",
      gap: "50px",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "flex-start",
      textAlign: "left",
      "& h2": {
        width: "50%",
      },
      "& p": {
        width: "50%",
      },
      "@media(max-width: 768px)": {
        gap: "24px",
        flexDirection: "column",
        justifyContent: "flex-start",
        "& h2": {
          width: "100%",
        },
        "& p": {
          width: "100%",
        },
      },
    },
    "& .body": {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      marginTop: "50px",
    },
    "@media only screen and (max-width: 600px)": {
      "& .header": {
        width: "100%",
      },
      "& .body": {
        flexDirection: "column",
        flexWrap: "wrap",
        rowGap: "15px",
      },
    },
    "& .container":{
      paddingBottom:'30px'
    },
    "@media only screen and (min-width: 1900px)": {
      "& .container": {
        paddingTop: "20px",
      },
    },
    "& .swiper-wrapper": {
      alignItems: "streach",
      padding: "16px 8px",
    },
  },

  commonPageFooterSection: {
    background:
      "transparent linear-gradient(90deg, #011D32 0%, #00182B 100%) 0% 0% no-repeat padding-box",
    "& .centerContainer": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      gap: "32px",
      width: "80%",
      margin: "0 auto",
      textAlign: "center",
    },
    "@media only screen and (max-width: 600px)": {
      "& .centerContainer": {
        width: "100%",
      },
    },
  },

  partnerSlide: {
    width: "144px !important",
    filter: "brightness(0.1)",
    "& img": {
      width: "144px",
    },
    "@media only screen and (max-width: 600px)": {
      width: "max-content !important",
      "& img": {
        width: "100px",
      },
      // marginRight: "20px !important",
    },
  },
  partnerSlider: {
    padding: "10px 0  65px !important",
    "@media only screen and (max-width: 600px)": {
      paddingBottom: "40px !important",
    },
  },
  integrationRightImage: {
    width: "100%",
  },

  adaptsBox: {
    gap: "16px",
    display: "flex",
    padding: "24px",
    background: "#fff",
    alignItems: "stretch",
    borderRadius: "20px",
    flexDirection: "column",
    justifyContent: "flex-start",
    boxShadow: "0px 0px 24px #D4E0E9",
    borderRadius: "16px",
    maxWidth: "380px",
    // minHeight: "220px",
    "@media only screen and (max-width: 600px)": {
      padding: "15px",
      maxWidth: "80%",
      gap: "15px",
    },
  },
  adaptDescription: {
    gap: "10px",
    minHeight: "80px",
    "@media only screen and (max-width: 600px)": {
      alignItems: "baseline",
    },
  },
  adaptBoxImg: {
    width: "48px",
    maxWidth: "48px",
    position: "relative",
    bottom: "0",
    marginBottom: "24px",
  },

  wpFaq: {
    "& section": {
      padding: "0px 0 40px !important",
    },
    "@media only screen and (max-width: 600px)": {
      "& section": {
        padding: "0px 0 40px !important",
      },
    },
  },
  aiPoweredContainer: {
    backgroundColor: "#F1FFFE",
  },
  aiPoweredClientContainer: {
    textAlign: "center",
  },
  integrationSection: {
    backgroundImage: `url(${industryintegrationImg})`,
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    paddingTop: "250px",
    "@media only screen and (max-width: 600px)": {
      paddingTop: "160px",
    },
    "& .primaryButtonOutline": {
      minWidth: "auto",
    },
  },
  integrationHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    "@media only screen and (max-width: 600px)": {
      flexDirection: "column",
    },
    "& div": {
      width: "50%",
      "@media only screen and (max-width: 600px)": {
        width: "100%",
      },
    },
    "& .buttonContaienr": {
      marginTop: "42px",
      "& a": {
        color: "#FF682A",

        "&:hover": {
          color: "#fff",
        },
      },
    },
  },

  testimonialSlide: {
    backgroundColor: "#F1FFFE",
  },

  combineSection: {
    position: "relative",
  },

  adaptSlider: {
    "@media only screen and (max-width: 600px)": {
      padding: "15px 15px 40px !important",
    },
    "@media only screen and (min-width: 1400px)": {
      padding: "15px 8rem 60px !important",
    },
    "@media only screen and (min-width: 1900px)": {
      padding: "15px 23rem 60px !important",
    },
  },
  absoulteCard: {
    position: "absolute",
    margin: "0 auto",
    width: "100%",
    top: "32%",
    "@media only screen and (max-width: 600px)": {
      top: "32%",
    },
  },
}));

const MasterSheet = () => {
  const classes = useStyles();

  useEffect(() => {
    // Select all cards that should have the effect
    const cardsToAnimate = [
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}:first-child`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard3`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard2`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard0`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard4`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.regularCard6`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard1`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard5`
      ),
      document.querySelector(
        `.${classes.statsContainer} .${classes.customerExperencesBox}.orangeCard7`
      ),
    ];

    const setupCard = (card) => {
      if (!card) return;

      card.classList.add("glass-effect");

      const setInitialPosition = () => {
        const rect = card.getBoundingClientRect();
        const topRightX = rect.width - 150;
        const topRightY = 0;

        card.style.setProperty("--before-left", `${topRightX}px`);
        card.style.setProperty("--before-top", `${topRightY}px`);
        card.style.setProperty("--before-opacity", "0.8");
      };

      setInitialPosition();

      let lastX = null;
      let lastY = null;

      const handleMouseMove = (e) => {
        const rect = card.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        lastX = x;
        lastY = y;

        card.style.setProperty("--before-left", `${x - 75}px`);
        card.style.setProperty("--before-top", `${y - 75}px`);
      };

      const handleMouseEnter = () => {
        if (lastX !== null && lastY !== null) {
          card.style.setProperty("--before-left", `${lastX - 75}px`);
          card.style.setProperty("--before-top", `${lastY - 75}px`);
        }
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handleMouseLeave = () => {
        card.style.setProperty("--before-opacity", "0.8");
      };

      const handlers = {
        mousemove: handleMouseMove,
        mouseenter: handleMouseEnter,
        mouseleave: handleMouseLeave,
        resize: setInitialPosition,
      };

      card.handlers = handlers;

      card.addEventListener("mousemove", handlers.mousemove);
      card.addEventListener("mouseenter", handlers.mouseenter);
      card.addEventListener("mouseleave", handlers.mouseleave);
      window.addEventListener("resize", handlers.resize);
    };

    cardsToAnimate.forEach(setupCard);

    return () => {
      cardsToAnimate.forEach((card) => {
        if (!card?.handlers) return;

        const { handlers } = card;
        card.removeEventListener("mousemove", handlers.mousemove);
        card.removeEventListener("mouseenter", handlers.mouseenter);
        card.removeEventListener("mouseleave", handlers.mouseleave);
        window.removeEventListener("resize", handlers.resize);
      });
    };
  }, [classes]);

  const allIcons = [
    {
      img: leadCaptureIcon,
      title: "Auto lead capture",
    },
    {
      img: contactManagemntIcon,
      title: "Contact management",
    },
    {
      img: pipelineIcon,
      title: "Pipeline management",
    },
    {
      img: omniChannelIcon,
      title: "Omnichannel CRM",
    },
    {
      img: emailMarketingIcon,
      title: "Email marketing",
    },
    {
      img: quatationIcon,
      title: "Quotation generation",
    },
    {
      img: salesForecastIcon,
      title: "Sales forecasting",
    },
    {
      img: opportunityMangeIcon,
      title: "Opportunity management",
    },
    {
      img: aiChatbotIcon,
      title: "AI chatbot",
    },
    {
      img: whatsappCrmIcon,
      title: "WhatsApp CRM",
    },
    {
      img: mobileCrmIcon,
      title: "Mobile CRM",
    },
    {
      img: utmTrackingIcon,
      title: "UTM tracking",
    },
    {
      img: realTimeDashboardIcon,
      title: "Real-time dashboard",
    },
    {
      img: voipToolIcon,
      title: "VOIP tool integration",
    },
    {
      img: videoConferencingIcon,
      title: "Video conferencing",
    },
  ];

  // Function to distribute icons across three tracks
  function distributeIcons(icons) {
    // Sort icons alphabetically to ensure consistent distribution
    const sortedIcons = [...icons].sort((a, b) =>
      a.title.localeCompare(b.title)
    );

    const logotrack1 = [];
    const logotrack2 = [];
    const logotrack3 = [];

    sortedIcons.forEach((icon, index) => {
      // Distribute icons based on their index
      switch (index % 3) {
        case 0:
          logotrack1.push(icon);
          break;
        case 1:
          logotrack2.push(icon);
          break;
        case 2:
          logotrack3.push(icon);
          break;
      }
    });

    return {
      logotrack1,
      logotrack2,
      logotrack3,
    };
  }

  // Get the distributed icons
  const { logotrack1, logotrack2, logotrack3 } = distributeIcons(allIcons);

  useEffect(() => {
    // Infinite scroll functionality

    class InfiniteScroll {
      constructor(row, speed) {
        this.row = row;
        this.track = row.querySelector(".logos-track");
        this.speed = speed;
        this.position = 0;
        this.direction = row.dataset.direction || "left";
        this.init();
      }

      init() {
        // Clone the track content
        const content = this.track.innerHTML;
        this.track.innerHTML = content + content + content;

        // Calculate total width
        const logos = this.track.querySelectorAll(".logo");
        let totalWidth = 0;
        logos.forEach((logo) => {
          totalWidth +=
            logo.offsetWidth +
            parseInt(getComputedStyle(logo).marginLeft) +
            parseInt(getComputedStyle(logo).marginRight);
        });

        // Set row height
        this.row.style.height = logos[0].offsetHeight + 20 + "px";

        // Set initial position for right-to-left movement
        if (this.direction === "left") {
          this.position = 0;
        } else {
          this.position = -this.track.offsetWidth / 3;
        }

        // Start animation
        this.animate();
      }

      animate() {
        const animate = () => {
          // Update position based on direction
          if (this.direction === "left") {
            this.position -= this.speed;
            // Reset position when one-third of content has scrolled
            const oneThirdWidth = -this.track.offsetWidth / 3;
            if (this.position <= oneThirdWidth) {
              this.position = 0;
            }
          } else {
            this.position += this.speed;
            // Reset position when one-third of content has scrolled
            if (this.position >= 0) {
              this.position = -this.track.offsetWidth / 3;
            }
          }

          this.track.style.transform = `translateX(${this.position}px)`;
          requestAnimationFrame(animate);
        };

        requestAnimationFrame(animate);
      }
    }

    // Initialize all rows with different speeds and directions
    document.querySelectorAll(".logos-row").forEach((row) => {
      const speed = parseFloat(row.dataset.speed) || 1;
      new InfiniteScroll(row, speed);
    });
  }, []);

  const benifitList = [
    {
      tag: "Integration",
      img: industryIntegration,
      title: "Work smarter with global integrations",
      desc: "Pepper Cloud integrates with tools like WhatsApp, Google, and Slack—helping teams automate tasks, streamline communication, and enhance productivity without disrupting their existing workflows or preferred platforms.",
    },
  ];

  const customerExperencesBoxContent = [
    {
      icon: contentIcon1,
      link: "/user-based-tools/messaging-communication/",
      heading: "Omnichannel CRM",
      data: "Unify customer interactions across email, chat, calls and social channels. Gain complete visibility, automate workflows and build stronger customer relationships with an all-in-one omnichannel CRM system.",
    },
    {
      icon: contentIcon2,
      link: "/user-based-tools/email-integration/",
      heading: "Email CRM",
      data: "Seamlessly connect your inbox with CRM, tasks, and contacts. Automate communication tracking, centralise client correspondence and boost productivity by syncing emails with your workflow in real time.",
    },
    {
      icon: contentIcon3,
      link: "/user-based-tools/crm-email-marketing-tools-integration/",
      heading: "Email Marketing CRM",
      data: "Design, schedule and personalise impactful campaigns. Analyse open and click rates, segment audiences, and nurture leads effectively with automated email marketing that drives engagement and conversions.",
    },
    {
      icon: contentIcon4,
      link: "/user-based-tools/crm-accounting-finance-integration",
      heading: "Accounting CRM",
      data: "Simplify financial operations with automated invoicing, expense tracking, and real-time reports. Ensure accuracy, compliance and cash flow control with integrated accounting and finance management tools.",
    },
    {
      icon: contentIcon5,
      link: "/user-based-tools/crm-calling-software-integration/",
      heading: "Voice & Video Calling CRM",
      data: "Connect with clients and teams seamlessly through high-quality VoIP and video calls. Enable real-time communication, screen sharing, and meeting recordings, all within your business ecosystem.",
    },
    {
      icon: contentIcon6,
      link: "/user-based-tools/google-integration/",
      heading: "Google Workspace CRM",
      data: "Empower teams with smart collaboration using Gmail, Drive, Docs and Calendar, all synced with your CRM. Streamline document management, scheduling and communication from one central platform.",
    },
    {
      icon: contentIcon7,
      link: "/user-based-tools/crm-for-e-commerce-integration/",
      heading: "E-commerce CRM",
      data: "Manage orders, inventory and customer data effortlessly. Integrate your online store with CRM for real-time sales tracking, personalised marketing and improved customer retention.",
    },
    {
      icon: contentIcon8,
      link: "/user-based-tools/best-workflow-management-tools/",
      heading: "Team Collaboration CRM",
      data: "Unite your workforce with shared workspaces, instant messaging, and task management. Encourage transparency, teamwork and productivity with tools designed for modern hybrid and remote teams.",
    },
  ];

  const partners = [
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
    { icon: partnerIcon1, alt: "caffeine solutions - Pepper Cloud Customer" },
    { icon: partnerIcon2, alt: "cuscapi - Pepper Cloud Customer" },
    { icon: partnerIcon3, alt: "TechData - Pepper Cloud Customer" },
    { icon: partnerIcon5, alt: "sis - Pepper Cloud Customer" },
    {
      icon: partnerIcon6,
      alt: "mustard seed systems corporation - Pepper Cloud Customer",
    },
    {
      icon: partnerIcon7,
      alt: "Singapore Maritime Foundation - Pepper Cloud Customer",
    },
    { icon: partnerIcon8, alt: "urban moods - Pepper Cloud Customer" },
  ];

  const faqs = [
    {
      question: "Can I use all the tools together?",
      answer: (
        <>
          Yes, Pepper Cloud allows you to integrate and use multiple tools
          simultaneously, giving your team a unified workspace to manage
          communication, files, meetings, and tasks.
        </>
      ),
    },
    {
      question: "Are these integrations easy to set up?",
      answer: (
        <>
          Absolutely. All integrations are designed to be plug-and-play,
          requiring no technical expertise. You can connect tools quickly and
          start streamlining your processes in minutes.
        </>
      ),
    },
    {
      question: "Will the data sync in real time?",
      answer: (
        <>
          Yes. Pepper Cloud ensures real-time two-way sync across all connected
          tools, keeping your customer data, events, and communications
          constantly updated.
        </>
      ),
    },
    {
      question: "Is my information secure across platforms?",
      answer: (
        <>
          Definitely. Pepper Cloud uses enterprise-grade encryption and
          permission controls to ensure your data stays secure, even across
          multiple third-party integrations.
        </>
      ),
    },
    {
      question: "Can I access tools on mobile?",
      answer: (
        <>
          Yes, all CRM tool integrations are fully mobile-compatible, allowing
          your team to stay productive and connected on the go.
        </>
      ),
    },
  ];

  const adaptList = [
    {
      pointer: "All-in-one CRM platform",
      desc: "Unify your files, calendars, contacts, and forms within a single connected CRM workspace.",
      img: adaptImg1,
      alt: "All-in-one CRM platform",
    },
    {
      pointer: "Real-time data sync",
      desc: "Automatically sync data across integrated tools to eliminate manual updates and ensure accuracy.",
      img: adaptImg2,
      alt: "Real-time data sync",
    },
    {
      pointer: "Smart automation workflows",
      desc: "Automate repetitive tasks like scheduling, data entry, and lead creation to save valuable time.",
      img: adaptImg3,
      alt: "Smart automation workflows",
    },
    {
      pointer: "Scalable for all teams",
      desc: "Adapt your integrations as your business grows without interrupting workflows or daily operations.",
      img: adaptImg4,
      alt: "Scalable for all teams",
    },
    {
      pointer: "Enterprise-grade security",
      desc: "Protect your data with robust encryption and secure access controls across all connected tools.",
      img: adaptImg5,
      alt: "Enterprise-grade security",
    },
    {
      pointer: "Mobile integration support",
      desc: "Access productivity integrations on mobile, keeping your business connected wherever you are.",
      img: adaptImg6,
      alt: "Mobile integration support",
    },
  ];

  return (
    <main>
      <SEO
        description={
          "Discover all CRM tools integrated with Pepper Cloud. Explore solutions for email marketing, voice calls, calendars, contacts, forms, and more—all in one place"
        }
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Pepper Cloud",
            legalName: "Pepper Cloud PTE LTD",
            url: "https://peppercloud.com/",
            logo: "https://peppercloud.com/icons/logo.png",
            foundingDate: "2017",
            address: [
              {
                "@type": "PostalAddress",
                streetAddress: "#04-01/02",
                addressLocality: "Blk 79 Ayer Rajah Crescent",
                addressRegion: "SG",
                postalCode: "139955",
                addressCountry: "Singapore",
              },
              {
                "@type": "PostalAddress",
                streetAddress:
                  "2nd Floor, Salarpuria Tower 1, 7th Block Koramangala",
                addressLocality: "Bengaluru",
                addressRegion: "KA",
                postalCode: "560095",
                addressCountry: "India",
              },
            ],
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "customer support",
              telephone: "+6566562616",
              email: ["sales@peppercloud.com", "support@peppercloud.com"],
            },
            sameAs: [
              "https://twitter.com/peppercloudpte",
              "https://www.linkedin.com/company/peppercloud/",
              "https://www.facebook.com/PepperCloudPteLtd",
              "https://www.instagram.com/pepper.cloud/",
            ],
          },
          {
            "@context": "https://schema.org/",
            "@type": "FAQPage",
            mainEntity: [
              {
                "@type": "Question",
                name: "What is the role of CRM in retail?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Retail CRM plays a crucial role in managing customer interactions, tracking sales, and enhancing service across both online and offline channels.",
                },
              },
              {
                "@type": "Question",
                name: "Why is a specialized CRM necessary for e-commerce?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "A specialized e-commerce CRM addresses challenges such as cart abandonment, personalized recommendations, and multichannel support, ultimately enhancing customer experience and driving sales.",
                },
              },
              {
                "@type": "Question",
                name: "Is investing in a CRM worthwhile for small businesses?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud CRM is beneficial for small e-commerce businesses as it improves customer service, streamlines operations, and enables data-driven decision-making, leading to growth and increased profitability.",
                },
              },
              {
                "@type": "Question",
                name: "Can Pepper Cloud assist with cart abandonment?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM automates cart abandonment recovery through targeted reminders and incentives, resulting in increased conversions.",
                },
              },
              {
                "@type": "Question",
                name: "How does Pepper Cloud facilitate multichannel sales?",
                acceptedAnswer: {
                  "@type": "Answer",
                  text: "Pepper Cloud's e-commerce CRM offers omnichannel capabilities, managing sales and customer interactions across websites, marketplaces, and social media platforms for a unified customer view.",
                },
              },
            ],
          },
        ]}
        keywords="CRM tools integration, Google Workspace integrated CRM, email marketing CRM, VoIP CRM integration, calendar CRM, contact management CRM, file management CRM, CRM communication tools"
        ogData={{
          "og:image": [
            "/meta/og/1X1/home.png",
            "/meta/og/1024X512/home.png",
            "/meta/og/1200X630/home.png",
          ],
        }}
        pathname={"https://peppercloud.com/user-based-tools/"}
        title={
          "CRM tools and integrations for smarter workflows | Pepper Cloud"
        }
      />

      <section className={classes.IndustrySection}>
        <div className="container">
          <div className={classes.aiSectionContainer}>
            <div className={classes.aiSectionLeft}>
              <motion.h1
                className="font-wix-semibold font-64  "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Top CRM tools to Simplify your business operations
              </motion.h1>
              <motion.p
                className="font-wix-regular font-18  "
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Pepper Cloud CRM brings all your tools together in emails,
                calendars, calls, contacts, forms, and files, in one smart
                platform. Streamline workflows, boost productivity, and improve
                team collaboration.
              </motion.p>
              <div className="buttonContaienr">
                {/* <Link
                  to={
                    "/whatsapp-crm/?utm_source=Homepage&utm_medium=CTA&utm_content=Explore+WhatApp+CRM"
                  }
                  initial={{ opacity: 1, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3 }}
                  className="transparentButton font-wix-medium font-16"
                >
                  Explore WhatApp CRM
                </Link> */}
                <Link
                  className=" primaryButton font-inter-medium font-16 font-white"
                  initial={{ opacity: 1, y: 20 }}
                  to={
                    "/contact/?utm_source=CRM+email+integration&utm_medium=Book+a+demo"
                  }
                  transition={{ duration: 0.3 }}
                  whileInView={{ opacity: 1, y: 0 }}
                >
                  Book a demo
                </Link>
              </div>
            </div>
            <motion.div
              className={classes.aiSectionRight}
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              <LazyImage
                alt={"WhatsApp CRM"}
                source={teamsPageHeroImg}
                width={"100%"}
              />
            </motion.div>
          </div>
        </div>
      </section>

      <section className={classes.performanceSection}>
        <div className="container">
          <div className={classes.integrationindustryHeader}>
            <div className={classes.integrationContent}>
              <motion.h2
                className="font-wix-semibold font-56 color-black7"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Explore powerful CRM tool integrations
              </motion.h2>
              <motion.p
                className="font-wix-regular font-18 colorWhite"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Streamline your business with Pepper Cloud’s suite of CRM
                integrations. Connect essential tools to manage communication,
                automate tasks, and improve team efficiency—all from one
                central, cloud-based CRM platform.
              </motion.p>
            </div>
          </div>
          <div className={classes.statsContainer}>
            {customerExperencesBoxContent.map((stat, index) => (
              <motion.div
                className={clsx(classes.customerExperencesBox)}
                key={index}
                transition={{ duration: 1, delay: index * 0.1 }}
                whileInView={{ opacity: [0, 1], y: [50, 0] }}
              >
                {/* <div className={classes.statsBoxHeader}>
                  <p className="font-18 color-purple3 font-wix-regular">
                    {stat.heading}
                  </p>
                </div> */}
                <div className={classes.customerExperencesBoxBody}>
                  <div className={classes.statsFontImg}>
                    <img alt={stat.alt} src={stat.icon} />
                  </div>

                  <p className="font-24 font-wix-semibold heading">
                    {stat.heading}
                  </p>
                  <p className="font-16 font-wix-regular font-white description">
                    {stat.data}
                  </p>
                  <Link className={classes.learnMorelink} to={stat.link}>
                    <span className="font-18 font-white font-wix-medium">
                      Learn more
                    </span>{" "}
                    <span className={classes.moreSideButton}>
                      <img alt="Learn more" src={moreSideRightButton} />
                    </span>
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className={classes.adaptFeatures}>
        <div className="container">
          <div className="header">
            <motion.h2
              className="font-wix-semibold font-56 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Why choose Pepper Cloud for CRM integrations
            </motion.h2>
            <motion.p
              className="font-wix-regular font-18 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Pepper Cloud unifies all your essential tools—emails, calendars,
              calls, and files—into one smart CRM. Automate workflows, access
              real-time data, and scale effortlessly with a secure,
              business-ready platform built for modern teams.
            </motion.p>
          </div>
        </div>
        <Swiper
          autoplay={{
            delay: 0,
            disableOnInteraction: false,
          }}
          breakpoints={{
            // For smaller screens (mobile)
            0: {
              slidesPerView: "auto",
              freeMode: true,
              // grabCursor: false,
              spaceBetween: 15,
              // autoplay: false,
              // modules: [],
            },
            // For larger screens (desktop)
            // 768: {
            //   slidesPerView: "auto",
            //   slidesPerGroup: 3,
            //   spaceBetween: 30,
            //   grabCursor: true,
            // },
          }}
          className={classes.adaptSlider}
          grabCursor={true}
          loop={true}
          modules={[Autoplay]}
          speed={5000}
          slidesPerView={"auto"}
          // centeredSlides={true}
          spaceBetween={30}
        >
          {adaptList.map((point, index) => (
            <SwiperSlide className={classes.adaptsBox}>
              <div className={classes.adaptBoxHeader}>
                <img
                  // alt={point.card.alt}
                  className={classes.adaptBoxImg}
                  src={point.img}
                />
                <p className="font-24 font-wix-semibold ">{point.pointer}</p>
              </div>
              <div className={classes.adaptDescription}>
                <p className="font-wix-regular font-18  ">{point.desc}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <section className={classes.combineSection}>
        <section className={classes.bussinessSuccesSection}>
          <div className={classes.integrationHeaderItem}>
            <div className={classes.integrationContent}>
              <motion.h2
                className="font-wix-semibold font-56 color-black7"
                initial={{ opacity: 1, y: 20 }}
                transition={{ duration: 0.3 }}
                whileInView={{ opacity: 1, y: 0 }}
              >
                Pepper Cloud CRM features tailored for business success
              </motion.h2>
            </div>
          </div>

          <section>
            <div className="logos-container">
              <div className="scroll-container">
                <div
                  className="logos-row"
                  data-direction="left"
                  data-speed="0.8"
                >
                  <div className="logos-track">
                    {logotrack1.map((logo) => (
                      <div className="logo font-18 font-wix-medium">
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="logos-row"
                  data-direction="right"
                  data-speed="0.4"
                >
                  <div className="logos-track">
                    {logotrack2.map((logo) => (
                      <div className="logo font-18 font-wix-medium">
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>

                <div
                  className="logos-row"
                  data-direction="left"
                  data-speed="0.8"
                >
                  <div className="logos-track">
                    {logotrack3.map((logo) => (
                      <div className="logo font-18 font-wix-medium">
                        <img alt={`${logo.title} integration`} src={logo.img} />
                        <p>{logo.title}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </section>
        <div className={classes.absoulteCard}>
          <TruestedSection background={true} />
        </div>

        {benifitList.map((benifit, index) => (
          <section className={classes.integrationSection}>
            <div className="container">
              <div className={classes.integrationHeader}>
                <div className={classes.integrationLeft}>
                  <motion.div
                    className="sectionTag"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    <p className="font-18  font-wix-semibold color-blue1">
                      {benifit.tag}
                    </p>
                  </motion.div>
                  <motion.h2
                    className="font-wix-semibold font-56 color-black1"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {benifit.title}
                  </motion.h2>
                  <motion.p
                    className="font-wix-regular font-18 color-black2 mt20"
                    initial={{ opacity: 1, y: 20 }}
                    transition={{ duration: 0.3 }}
                    whileInView={{ opacity: 1, y: 0 }}
                  >
                    {benifit.desc}
                  </motion.p>
                  <div className="buttonContaienr">
                    <Link
                      className=" primaryButtonOutline font-wix-medium font-18  "
                      to={"/crm-integrations"}
                    >
                      Explore CRM integrations
                    </Link>
                  </div>
                </div>
                <div className={classes.integrationRight}>
                  <img
                    alt={benifit.title}
                    className={classes.integrationRightImage}
                    src={benifit.img}
                  />
                </div>
              </div>
            </div>
          </section>
        ))}
      </section>

      <section className={classes.aiPoweredContainer}>
        <div className="container">
          <div className={classes.aiPoweredClientContainer}>
            <motion.h2
              className="font-wix-medium font-24 color-black1"
              initial={{ opacity: 1, y: 20 }}
              transition={{ duration: 0.3 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Pepper Cloud CRM - Trusted by many businesses
            </motion.h2>
          </div>
        </div>
        <Swiper
          allowTouchMove={false}
          autoplay={{
            delay: 100,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }}
          className={classes.partnerSlider}
          loop={true}
          modules={[Autoplay]}
          slidesPerView="auto"
          spaceBetween={60}
          speed={2000}
        >
          {partners.map((partner) => (
            <SwiperSlide className={classes.partnerSlide}>
              <img alt={partner.alt} src={partner.icon} />
            </SwiperSlide>
          ))}
        </Swiper>
      </section>
      <section className={classes.testimonialSlide}>
        <TestimonialSlider
          desc={
            "Discover how businesses are transforming customer engagement with Pepper Cloud."
          }
          heading={"Trusted by businesses worldwide"}
          noButton={true}
        />
      </section>

      <div className={classes.wpFaq}>
        <FaqSection backgroundColor={"#FFFFFF"} faqs={faqs} heading={"FAQs"} />
      </div>
      <section className={classes.commonPageFooterSection}>
        <div className="container">
          <div className="centerContainer">
            <motion.h2
              className="font-wix-medium font-56 font-white"
              initial={{ opacity: 1, y: 30 }}
              transition={{ duration: 0.5 }}
              whileInView={{ opacity: 1, y: 0 }}
            >
              Power your business with integrated CRM tools
            </motion.h2>
            <Link
              className="primaryButton font-20 font-wix-medium font-white"
              to="/contact/?utm_source=CRM+email+integration&utm_medium=Book+a+demo"
            >
              Get started
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MasterSheet;
